import React, {Component} from "react";
import {connect} from "react-redux";

class Preloader extends Component {
    get preloader() {
        return this.props.hasOwnProperty('preloader') ? this.props.preloader : {};
    }
    /**
     * 프리로더 노출
     * @returns {*|string}
     */
    get display() {
        return this.preloader.display || '';
    }

    /**
     * 프리로더 메세지
     * @returns {*|string}
     */
    get message() {
        return this.preloader.message || '';
    }

    /**
     * 프리로더 랜더링
     * @returns {JSX.Element}
     */
    render() {
        return (
            <div className={`preloader ${this.display ? '' : 'hide'}`} id="box-container">
                <div className="box-wrap">
                    <div className='boxes box1'></div>
                    <div className='boxes box2'></div>
                    <div className='boxes box3'></div>
                </div>
            </div>
        );
    }
}

const preloaderStateToProps = (state) => ({
    preloader: state.preloader,
});

export default connect(preloaderStateToProps)(Preloader);


// WEBPACK FOOTER //
// ./src/pages/include/preloader.jsx